import { useEffect, useState } from "react"
import { _AmortizationType, _single } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable } from "../../../theme/Component/BasicTable"
import { ListMenu } from "../../../theme/Component/ListMenu"
import { ModalConfirm } from "../../../theme/Component/ModalConfirm"
import { Modal } from "../../../theme/Component/Modal"



export const AmortizationType = () => {

    const { instance, setLista, setBean, bean, lista, handleChange } = useDataBean(_AmortizationType);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const head = [
        { title: 'ID', property: 'IDAmortizationType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Clase Implementación Java', property: 'ClassForName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getAmortizationTypeCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const updateIten = () => {
        instance.updateAmortizationType(bean).then(
            (resp) => {
                setModal({ ...modal, "view": false })
                getLista()
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteItem = () => {
        instance.deleteAmortizationType(bean.IDAmortizationType).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Tipo de Amortización" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Tipo de Amortización" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Tipo de Amortización` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Tipos de Amortización" >
            <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar {bean.IDAmortizationType} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateIten}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label >Clase Implementación Java</label>
                            <input type="text" className="form-control" name="ClassForName" value={bean.ClassForName} onChange={handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            </div>

        </BasicPage>
    )
}